var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { expressionParser } from '@ane/antlr/lib/FilterExpression/utils/ExpressionParser';
import * as _ from 'lodash';
import { getAnalysisGroupHeaders } from './AnalysisGroupHeaders';
import { SupportedTriggerType } from '../constants/module.constants';
import { parseTriggerCondition } from '../views/AnalysisTemplate/common/AutoGeneratedTriggering.utils';
import { ValidationRequestStatus } from '../views/AnalysisTemplate/ProgressionScorecard/ProgressionScoreCardList/ValidationStatus';
import { IReducerKeys } from '../views/AnalysisTemplate/ProgressionScorecard/ProgressionScorecard.ducks';
import EnvironmentService from '@ane/core/lib/services/EnvironmentService';
const AnalysisTemplateType = {
    TRIGGERED: 'Triggered',
    UNTRIGGERED: 'Untriggered',
};
export const parseAutomaticAnalysis = (mdsAnalysisConfigData, metricsAnalysisTemplates, assignmentUnit = '') => {
    const { AnalysisRules = [] } = mdsAnalysisConfigData !== null && mdsAnalysisConfigData !== void 0 ? mdsAnalysisConfigData : {};
    const progressionScorecardDictionary = _.reduce(AnalysisRules, (resultSoFar, current) => {
        var _a;
        const { Condition = {}, SelectedAnalysisTemplates = [] } = current;
        const conditionStr = parseAnalysisCondition(Condition);
        const includeAnalysisTemplate = !!!assignmentUnit ||
            !(Condition === null || Condition === void 0 ? void 0 : Condition.AssignmentUnits) ||
            !(Condition === null || Condition === void 0 ? void 0 : Condition.AssignmentUnits.length) ||
            ((_a = Condition === null || Condition === void 0 ? void 0 : Condition.AssignmentUnits) !== null && _a !== void 0 ? _a : []).includes(assignmentUnit);
        includeAnalysisTemplate &&
            SelectedAnalysisTemplates.forEach((s) => {
                var _a, _b, _c, _d, _e, _f;
                const tasks = (_d = (_c = (_b = (_a = metricsAnalysisTemplates === null || metricsAnalysisTemplates === void 0 ? void 0 : metricsAnalysisTemplates[s]) === null || _a === void 0 ? void 0 : _a[IReducerKeys.analysis_template_async]) === null || _b === void 0 ? void 0 : _b.data) === null || _c === void 0 ? void 0 : _c.taskSchedule) === null || _d === void 0 ? void 0 : _d.tasks;
                resultSoFar = Object.assign(Object.assign({}, resultSoFar), { [s]: {
                        id: s,
                        name: s,
                        lastModifiedDate: '',
                        isActive: true,
                        type: 'Untriggered',
                        schedule: convertTasksToDateRangeUnits(tasks),
                        conditions: (conditionStr + ' ' + ((_f = (_e = resultSoFar === null || resultSoFar === void 0 ? void 0 : resultSoFar[s]) === null || _e === void 0 ? void 0 : _e.conditions) !== null && _f !== void 0 ? _f : '')).trim(),
                    } });
            });
        return resultSoFar;
    }, {});
    return Object.values(progressionScorecardDictionary);
};
const includeAnalysisTemplateAndType = (assignmentUnit, Condition, featureAutoTriggerStateValue) => {
    var _a;
    const includeAnalysisTemplateExpression = !!!assignmentUnit ||
        !(Condition === null || Condition === void 0 ? void 0 : Condition.AssignmentUnits) ||
        !(Condition === null || Condition === void 0 ? void 0 : Condition.AssignmentUnits.length) ||
        ((_a = Condition === null || Condition === void 0 ? void 0 : Condition.AssignmentUnits) !== null && _a !== void 0 ? _a : []).includes(assignmentUnit);
    if (featureAutoTriggerStateValue === null || featureAutoTriggerStateValue === undefined || !featureAutoTriggerStateValue) {
        if (Condition.IsFeatureGateTriggeringSupported === null || Condition.IsFeatureGateTriggeringSupported === undefined) {
            return {
                includeAnalysisTemplate: includeAnalysisTemplateExpression,
                analysisTemplateType: AnalysisTemplateType.UNTRIGGERED,
            };
        }
        else if (Condition.IsFeatureGateTriggeringSupported) {
            return {
                includeAnalysisTemplate: false,
                analysisTemplateType: AnalysisTemplateType.TRIGGERED,
            };
        }
        else {
            return {
                includeAnalysisTemplate: includeAnalysisTemplateExpression,
                analysisTemplateType: AnalysisTemplateType.UNTRIGGERED,
            };
        }
    }
    else {
        if (Condition.IsFeatureGateTriggeringSupported === null || Condition.IsFeatureGateTriggeringSupported === undefined) {
            return {
                includeAnalysisTemplate: includeAnalysisTemplateExpression,
                analysisTemplateType: AnalysisTemplateType.UNTRIGGERED,
            };
        }
        else if (Condition.IsFeatureGateTriggeringSupported) {
            return {
                includeAnalysisTemplate: includeAnalysisTemplateExpression,
                analysisTemplateType: AnalysisTemplateType.TRIGGERED,
            };
        }
        else {
            return {
                includeAnalysisTemplate: false,
                analysisTemplateType: AnalysisTemplateType.UNTRIGGERED,
            };
        }
    }
};
export const parseAutomaticAnalysisWithFeatureAutoTriggerState = (featureAutoTriggerState, mdsAnalysisConfigData, metricsAnalysisTemplates, assignmentUnit = '') => {
    const { AnalysisRules = [] } = mdsAnalysisConfigData !== null && mdsAnalysisConfigData !== void 0 ? mdsAnalysisConfigData : {};
    const progressionScorecardDictionary = _.reduce(AnalysisRules, (resultSoFar, current) => {
        const { Condition = {}, SelectedAnalysisTemplates = [] } = current;
        const conditionStr = parseAnalysisCondition(Condition);
        const { includeAnalysisTemplate, analysisTemplateType } = includeAnalysisTemplateAndType(assignmentUnit, Condition, featureAutoTriggerState === null || featureAutoTriggerState === void 0 ? void 0 : featureAutoTriggerState.value);
        includeAnalysisTemplate &&
            SelectedAnalysisTemplates.forEach((s) => {
                var _a, _b, _c, _d, _e, _f;
                const tasks = (_d = (_c = (_b = (_a = metricsAnalysisTemplates === null || metricsAnalysisTemplates === void 0 ? void 0 : metricsAnalysisTemplates[s]) === null || _a === void 0 ? void 0 : _a[IReducerKeys.analysis_template_async]) === null || _b === void 0 ? void 0 : _b.data) === null || _c === void 0 ? void 0 : _c.taskSchedule) === null || _d === void 0 ? void 0 : _d.tasks;
                resultSoFar = Object.assign(Object.assign({}, resultSoFar), { [s + analysisTemplateType]: {
                        id: s,
                        name: s,
                        lastModifiedDate: '',
                        isActive: true,
                        type: analysisTemplateType,
                        schedule: convertTasksToDateRangeUnits(tasks),
                        conditions: (conditionStr + ' ' + ((_f = (_e = resultSoFar === null || resultSoFar === void 0 ? void 0 : resultSoFar[s + analysisTemplateType]) === null || _e === void 0 ? void 0 : _e.conditions) !== null && _f !== void 0 ? _f : '')).trim(),
                    } });
            });
        return resultSoFar;
    }, {});
    return Object.values(progressionScorecardDictionary);
};
export const parseAnalysisCondition = ({ TrafficFiltersExpression = '' }) => {
    const trafficFilters = expressionParser(TrafficFiltersExpression);
    return Object.keys(trafficFilters)
        .map((filterKey) => {
        const filter = trafficFilters[filterKey];
        const { operator, values } = getBaseValuesAndOperator(filter);
        const isOperatorNotIn = (operator === null || operator === void 0 ? void 0 : operator.toUpperCase()) === 'NOTIN';
        return `${filterKey}: ${isOperatorNotIn ? 'not(' : ''}${values.map((v) => v).join(',')}${isOperatorNotIn ? ')' : ''}`;
    })
        .join(' ');
};
export const getBaseValuesAndOperator = (audienceFilter) => {
    if (audienceFilter.type === 'Base') {
        const audienceFilterClause = audienceFilter.clause;
        return {
            values: audienceFilterClause.type === 'SingleValue'
                ? [audienceFilterClause.values.toString()]
                : [...audienceFilterClause.values.map((v) => v.toString())],
            operator: audienceFilterClause.operator,
        };
    }
    return { values: [], operator: '' };
};
export const getProgressionScorecardItems = (input) => {
    const { analysisGroupData, featureAutoTriggerState, mdsAnalysisConfigData, metricsAnalysisTemplates, newAnalysisCreated = false, assignmentUnit = '', } = input;
    const automaticAnalysisTemplateList = EnvironmentService.enableAutoTriggerToggle()
        ? parseAutomaticAnalysisWithFeatureAutoTriggerState(featureAutoTriggerState, mdsAnalysisConfigData, metricsAnalysisTemplates, assignmentUnit)
        : parseAutomaticAnalysis(mdsAnalysisConfigData, metricsAnalysisTemplates, assignmentUnit);
    const templateList = _.filter(_.flatten(_.map(analysisGroupData, (analysisGroup) => _.map(analysisGroup.analysisList, (analysisListItem) => (Object.assign(Object.assign({}, analysisListItem), { type: analysisGroup.type, analysisGroupId: analysisGroup.id }))))), (template) => template.isActive);
    const groups = getAnalysisGroupHeaders(automaticAnalysisTemplateList, analysisGroupData !== null && analysisGroupData !== void 0 ? analysisGroupData : [], newAnalysisCreated);
    const filteredGroups = _.filter(groups, (group) => group.count > 0);
    return { items: [...automaticAnalysisTemplateList, ...templateList], groups: filteredGroups };
};
export const getSelectionString = (selectedItems, analysisGroups) => {
    let groups = {};
    _.forEach(selectedItems, (item) => {
        _.forEach(item, (template) => {
            var _a, _b;
            const analysisGroup = _.find(analysisGroups, (group) => group.id === template.analysisGroupId);
            const analysisGroupName = (_a = analysisGroup === null || analysisGroup === void 0 ? void 0 : analysisGroup.name) !== null && _a !== void 0 ? _a : '';
            groups = Object.assign(Object.assign({}, groups), { [analysisGroupName]: [...((_b = groups === null || groups === void 0 ? void 0 : groups[analysisGroupName]) !== null && _b !== void 0 ? _b : []), template.name] });
        });
    });
    const jsonString = JSON.stringify(groups);
    return jsonString
        .replace(/[{}:\n\t"]/g, '')
        .replace(/[,]/g, ', ')
        .replace(/[[]/g, ' [')
        .trim();
};
export const getSupportedTriggerType = (triggerExpression, sideStreamTriggerExpression, analysisConfig) => {
    var _a, _b, _c;
    const defaultTriggerExpression = (_b = (_a = analysisConfig.TriggerFilterConfigs) === null || _a === void 0 ? void 0 : _a['EventViewSideStream']) === null || _b === void 0 ? void 0 : _b.Condition;
    const defaultFeatureGateExpression = _.replace((_c = analysisConfig === null || analysisConfig === void 0 ? void 0 : analysisConfig.FeatureGateTriggerCondition) !== null && _c !== void 0 ? _c : '', '"{FeatureGateName}"', '');
    if (triggerExpression === defaultTriggerExpression) {
        if (!!sideStreamTriggerExpression) {
            const { isAutomatic } = parseTriggerCondition(sideStreamTriggerExpression);
            if (isAutomatic)
                return SupportedTriggerType.auto_generate;
            return SupportedTriggerType.side_stream_manual;
        }
        return SupportedTriggerType.no_trigger;
    }
    else if (!!defaultFeatureGateExpression && _.startsWith(triggerExpression, defaultFeatureGateExpression))
        return SupportedTriggerType.feature_gate;
    else
        return SupportedTriggerType.manual;
};
export const getAnalysisTemplateWithoutValidation = (analysisTemplate) => {
    const { status, validationError } = analysisTemplate, rest = __rest(analysisTemplate, ["status", "validationError"]);
    return rest;
};
export const getAnalysisGroupWithoutValidation = (analysisGroup) => {
    const { analysisList } = analysisGroup, rest = __rest(analysisGroup, ["analysisList"]);
    return Object.assign(Object.assign({}, rest), { analysisList: _.map(analysisList, (template) => getAnalysisTemplateWithoutValidation(template)) });
};
export const isAnalysisTemplateValidationComplete = (analysisTemplate, isNewAnalysis = false) => 
// if analysis is new, validation is not complete if status shows as not required
// backend shows status as not required for new analysis before validation actually begins
analysisTemplate.status === ValidationRequestStatus.Completed ||
    analysisTemplate.status === ValidationRequestStatus.Failed ||
    (isNewAnalysis ? false : analysisTemplate.status === ValidationRequestStatus.NotRequired);
export const isAnalysisGroupValidationPending = (analysisGroup, newAnalysisCreated = false) => {
    const activeTemplates = _.filter(analysisGroup.analysisList, (template) => template.isActive);
    return _.some(activeTemplates, 
    // newly created analysis will be the last in list
    (template, i) => !isAnalysisTemplateValidationComplete(template, newAnalysisCreated && i === activeTemplates.length - 1));
};
export const convertTasksToDateRangeUnits = (tasks) => _.map(tasks, (t) => ({ startUnit: Number(t.start), endUnit: Number(t.end), timeUnit: t.type }));

//# sourceMappingURL=ProgressionScorecardList.utils.js.map
